<template>
  <div>
    <el-form
      ref="form"
      :rules="rules"
      label-width="120px"
      :model="form"
      :hide-required-asterisk="false"
    >
      <el-form-item label="课题属性:" prop="courseGroup" key="1">
        <el-select
          ref="ktsx"
          v-model="form.courseGroup"
          placeholder="请选择课题属性"
          class="filter-item"
          style="width: 100%"
          :disabled="mxParams.courseGroup == 3"
          @change="handleChangeKtsx"
        >
          <el-option
            v-for="item in ktsxOptions"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label=""
        prop="courseAttribute"
        key="1"
        v-if="mxParams.addCourseType == 2 && form.courseGroup != 3"
      >
        <el-radio-group v-model="form.courseAttribute">
          <el-radio label="1">正式</el-radio>
          <el-radio label="3">临时</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="项目类型:"
        prop="courseProject"
        key="1"
        v-if="xmlxActive"
      >
        <el-select
          ref="xmlx"
          v-model="form.courseProject"
          placeholder="请选择项目类型"
          class="filter-item"
          style="width: 100%"
        >
          <el-option
            v-for="item in xmlxOptions"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="课题名称:" prop="courseName" key="1">
        <el-input
          show-word-limit
          placeholder="请输入课题名称"
          maxlength="100"
          v-model="form.courseName"
        ></el-input>
      </el-form-item>
      <el-form-item label="负责人:" prop="courseLeader" key="1">
        <treeselect
          v-model="form.courseLeader"
          placeholder="请选择员工"
          :options="deptUser"
          :disable-branch-nodes="true"
          :show-count="true"
          value-consists-of="LEAF_PRIORITY"
          no-results-text="未搜到任何结果"
          :clear-on-select="true"
          :normalizer="normalizer"
          style="width: 100%"
          size="small"
        />
      </el-form-item>
      <el-form-item label="课题主要成员:" prop="ygbh" key="1">
        <treeselect
          v-model="form.ygbh"
          placeholder="请选择员工"
          :options="deptUser"
          :disable-branch-nodes="true"
          :show-count="true"
          value-consists-of="LEAF_PRIORITY"
          no-results-text="未搜到任何结果"
          :clear-on-select="true"
          :normalizer="normalizer"
          style="width: 100%"
          size="small"
          :multiple="true"
        />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { getDictData } from "@/api/task.js";
import { addCourse } from "@/api/course.js";
import { mapGetters } from "vuex";

export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      form: {
        courseGroup: null,
        courseAttribute: null,
        courseProject: null,
        courseName: null,
        courseLeader: null,
        ygbh: null,
      },
      rules: {
        courseGroup: [
          { required: true, message: "课题属性不能为空", trigger: "change" },
        ],

        courseAttribute: [
          { required: true, message: "课题类别不能为空", trigger: "change" },
        ],
        courseProject: [
          { required: true, message: "项目类型不能为空", trigger: "change" },
        ],
        courseName: [
          { required: true, message: "课题名称不能为空", trigger: "change" },
        ],
        courseLeader: [
          { required: true, message: "课题负责人不能为空", trigger: "change" },
        ],
        ygbh: [
          { required: true, message: "课题成员不能为空", trigger: "change" },
        ],
      },
      ktsxOptions: [],
      xmlxOptions: [],
      xmlxActive: false,
    };
  },
  created() {
    if (this.mxParams.courseGroup) {
      this.form.courseGroup = this.mxParams.courseGroup;
      if (this.form.courseGroup == 3) {
        this.xmlxActive = true;
      } else {
        this.xmlxActive = false;
      }
    }
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    getDictData("pmp_course_project", 1).then((res) => {
      if (res.code === 0) {
        this.xmlxOptions = res.data;
      }
    });
    getDictData("pmp_course_group", 1).then((res) => {
      if (res.code === 0) {
        if (this.mxParams.addCourseType == 1) {
          let temp = [];
          for (let i of res.data) {
            if (i.dictValue != 3) {
              temp.push(i);
            }
          }
          this.ktsxOptions = temp;
        } else {
          this.ktsxOptions = res.data;
        }
      }
    });
  },
  mounted() {},

  methods: {
    saveForm() {
      let ygbh = null;
      if (this.form.ygbh && this.form.ygbh.length > 0) {
        ygbh = this.form.ygbh.join(",");
      }
      if (!this.form.courseAttribute) {
        this.form.courseAttribute = this.mxParams.isIndex ? "1" : "3";
      }
      addCourse({ ...this.form, ygbh }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          if (this.mxParams.isIndex == 1) {
            this.$router.push({ name: "courseList" });
          } else {
            this.$emit("getParentForm");
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleChangeKtsx(e) {
      if (e == 3) {
        this.xmlxActive = true;
      } else {
        this.xmlxActive = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .vue-treeselect__multi-value-item {
  display: block;
  height: 36px;
  line-height: 36px;
}
::v-deep .vue-treeselect__multi-value {
  height: 40px;
}
</style>